import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import httpClient from 'utils/httpClient';
import { RETRIEVE_SESSION_URL } from './retrieveSessionContent';
import { queryClient } from 'AppProvider';
import { GET_TESTING_RESULT_BY_COURSE_ID } from './retrieveTestResult';

const DELETE_TEST_RESULT_VIDEO = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-session-video`;

export type DeleteTestResultVideoBody = {
  id: number;
  courseId: number;
  indices: number[];
};

export type DeleteTestResultVideoResponse = {};

export const deleteTestResultVideo = ({
  id,
  courseId,
  indices,
}: DeleteTestResultVideoBody) => {
  return httpClient.delete<DeleteTestResultVideoResponse>(
    DELETE_TEST_RESULT_VIDEO(id, courseId),
    { params: { indices } },
  );
};

export const useDeleteTestResultVideo = (
  opts?: UseMutationOptions<
    AxiosResponse<DeleteTestResultVideoResponse>,
    AxiosError<any>,
    DeleteTestResultVideoBody
  >,
) => {
  return useMutation<
    AxiosResponse<DeleteTestResultVideoResponse>,
    AxiosError<any>,
    DeleteTestResultVideoBody
  >(deleteTestResultVideo, {
    ...opts,
    onSuccess: (_, { courseId, indices }) => {
      // Optmistic UI update: remove the deleted video indices from the cache immediately
      // This is necessary because the query might be disabled (e.g. during "Add Result" mode)
      queryClient.setQueryData(
        [GET_TESTING_RESULT_BY_COURSE_ID(courseId)],
        (old: any) => {
          if (!old?.data?.data?.video_url) return old;
          const newVideos = [...old.data.data.video_url];
          // Delete from highest index to lowest so indices don't shift
          const sortedIndices = [...indices].sort((a, b) => b - a);
          sortedIndices.forEach(index => {
            newVideos.splice(index, 1);
          });
          return {
            ...old,
            data: {
              ...old.data,
              data: {
                ...old.data.data,
                video_url: newVideos,
              },
            },
          };
        },
      );
      // Fallback invalidation
      queryClient.invalidateQueries([
        GET_TESTING_RESULT_BY_COURSE_ID(courseId),
      ]);
    },
  });
};
